import Feedback from './Component';

export default Feedback;